import { pages } from '../data/page';
import templates from '../data/templates';

export interface SwatchBase {
    value: string;
    label: string;
    index: number;
    meta?: any;
}

export interface Swatch extends SwatchBase {
    material: MaterialKey;
}

export interface Material {
    swatches: Swatch[];
    name: string;
    meta?: any;
}

// export type MaterialKey = keyof typeof materials;
export type MaterialKey = 'icarexPc31' | 'chikara';

export interface Materials {
    [index: string]: Material;
}

export enum PartType {
    Panel = 'panel',
    Rod = 'rod',
    UpperSpreader = 'upperSpreader',
    LowerSpreader = 'lowerSpreader',
    LeadingEdge = 'leadingEdge',
    Enforcment = 'enforcment',
    Standoff = 'standoff',
    Misc = 'misc',
}

export interface Part {
    id: number;
    name: string;
    type: PartType;
    color?: string;
    swatch?: Swatch;
    notes?: string;
    hidden?: boolean;
}

export interface Panel extends Part {
    element?: HTMLElement;
}

export interface Kite {
    svg: string;
    parts?: Part[];
    name: string;
    id?: string; // with store v2
    template: keyof typeof templates;
    meta: {
        notes?: string;
    };
    variation?: string;
}

export interface Template {
    svg: string;
    meta: {
        name?: string;
        designer?: string;
        desingerNotes?: string;
        buildPlans?: string;
        manufacturerContact?: string;
    };
    variations?: string[];
}

export interface Templates {
    [index: string]: Template;
}

export type TemplateKey = keyof typeof templates;

export interface TemplateRestriction {
    isCommercial: boolean;
    materials: MaterialKey[];
}

export interface TemplateRule {
    key: TemplateKey;
    className?: string;
    variation?: string;
    panels: {
        panelIds: Part['id'][];
        swatch: Swatch;
    }[];
    globalColorIds?: Part['id'][];
    forbiddenColors?: {
        material: MaterialKey;
        swatchIndices: Swatch['index'][];
    }[];
}

export type PageKey = keyof typeof pages;

export interface Store {
    meta: {
        version: number;
    };
    draft?: Kite;
    kites: {
        [index: string]: Kite;
    };
    session: {
        current: string;
        page: PageKey;
        menuOpen: boolean;
    };
    editor: Editor;
}

export interface Editor {
    swatch?: Swatch;
    draftSaved?: boolean;
    part?: Part;
    shadow?: boolean;
    material?: MaterialKey;
}
